const RecommendationWidgetActionTypes = {
  SET_ROWS: 'SET_ROWS',
  SET_START: 'SET_START',
  SET_WIDGET: 'SET_WIDGET'
};

export default RecommendationWidgetActionTypes;
